// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiDrop } from '../models/ApiDrop';
import { HttpFile } from '../http/http';

export class ApiUndiscoveredDrop {
    'drop': ApiDrop | null;
    'left_to_vote_in_current_round': number;
    'total_count': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "drop",
            "baseName": "drop",
            "type": "ApiDrop",
            "format": ""
        },
        {
            "name": "left_to_vote_in_current_round",
            "baseName": "left_to_vote_in_current_round",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "total_count",
            "baseName": "total_count",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiUndiscoveredDrop.attributeTypeMap;
    }

    public constructor() {
    }
}

